// Traduções para o calendário em português
//Textos convertidos para br do calendario
export const defaultMessages = {
  date: 'Data',
  time: 'Tempo',
  event: 'Evento',
  allDay: 'Dia Todo',
  week: 'Semana',
  work_week: 'Semana de trabalho',
  day: 'Dia',
  month: 'Mês',
  previous: '<',
  next: '>',
  yesterday: 'Ontem',
  tomorrow: 'Amanhã',
  today: 'Hoje',
  agenda: 'Agenda',
  noEventsInRange: 'Não existe eventos neste intervalo.',
  showMore: function showMore(total) {
    return '+' + total + ' mais';
  }
};
